const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const { Base64 } = require('js-base64');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json',
  };
  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getIncomeOverviewData(portfolioId, startDate, endDate, metaData) {
      const url = getUrl('income-history-aggregate');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };

      const oPortfolioID = portfolioId.replace(/-/gi,'.');
      const body = {
                  pfId: oPortfolioID,
                  userId: parsedMetaData.qs.userId,
                  destinationCurrency: parsedMetaData.qs.destinationCurrency,
                  branchCode:parsedMetaData.portfolio.branchCode,
                  fromDate: startDate,
                  toDate: endDate,
                  langCode: parsedMetaData.portfolio.language
                  };
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body }
      ));

    },
    getIncomeOverviewLUXData(inputParam, metaData) {
      const url = getUrl('income-history-aggregate');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const params = inputParam.split('#@#');

      const oPortfolioID = Base64.decode(params[0]).replace(/-/gi,'.');
      const body = {
                  pfId: oPortfolioID,
                  userId: parsedMetaData.qs.userId,
                  destinationCurrency: parsedMetaData.qs.destinationCurrency,
                  branchCode:parsedMetaData.portfolio.branchCode,
                  fromDate: params[1],
                  toDate: params[2],
                  langCode: parsedMetaData.portfolio.language
                  };
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body }
      ));

    },


   getIncomeTransactionList(portfolioId, startDate, endDate,prodType, metaData) {
      const url = getUrl('income-expense-transactions');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const oPortfolioID = portfolioId.replace(/-/gi,'.');
      const body = {
                  pfId: oPortfolioID,
                  userId: parsedMetaData.qs.userId,
                  destinationCurrency: parsedMetaData.qs.destinationCurrency,
                  branchCode:parsedMetaData.portfolio.branchCode,
                  fromDate: startDate,
                  toDate: endDate,
                  prodType:prodType,
                  langCode: parsedMetaData.portfolio.language
                  };
      return requestHandler(merge(
        {},
        reqOpts,
        { url, body }
      ));

    },

    getCHIncomeTransactionList(portfolioId, startDate, endDate, prodType, ieFlag, metaData) {

      const url = getUrl('income-expense-transactions');
      const parsedMetaData = parseRequestMetaData(metaData);
        const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const oPortfolioID = Base64.decode(portfolioId).replace(/-/gi,'.');
      const body = {
                  pfId: oPortfolioID,
                  userId: parsedMetaData.qs.userId,
                  destinationCurrency: parsedMetaData.qs.destinationCurrency,
                  branchCode:parsedMetaData.portfolio.branchCode,
                  fromDate: startDate,
                  toDate: endDate,
                  prodType: prodType,
                  langCode: parsedMetaData.portfolio.language,
                  ieFlag: ieFlag
                  };

      return requestHandler(merge(
        {},
        reqOpts,
        { url, body }
      ));

    }

    // getIncomeOverviewCHData(portfolioId, startDate, endDate, selLanguageCode, metaData) {

    //   const url = getUrl('income-history-aggregate');
    //   const parsedMetaData = parseRequestMetaData(metaData);
    //     const reqOpts = {
    //     headers: merge(headers, parsedMetaData.headers),
    //     method: 'POST',
    //     json: true
    //   };

    //   const oPortfolioID = portfolioId.replace(/-/gi,'.');
    //   const body = {
    //               pfId: oPortfolioID,
    //               userId: parsedMetaData.qs.userId,
    //               destinationCurrency: parsedMetaData.qs.destinationCurrency,
    //               branchCode:parsedMetaData.portfolio.branchCode,
    //               fromDate: startDate,
    //               toDate: endDate,
    //               langCode: selLanguageCode
    //               };


    //   return requestHandler(merge(
    //     {},
    //     reqOpts,
    //     { url, body }
    //   ));

    // }

  };
}

module.exports = apiFactory;
